import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthorizedRouteFactory} from '@application/helper/routing/authorized-route-factory';
import {RouteUtils} from '@application/helper/routing/route-utils';
import {canActivatePermissionGuard} from '@application/security/can-activate-permission.guard';
import {canDeactivateRouteWithUnsavedChanges} from '@application/security/can-deactivate-unsaved-changes-notifier.guard';
import {AddWeaveProductPageComponent} from './add/add-weave-product-page.component';
import {WeaveProductOverviewPageComponent} from './overview/weave-product-overview-page.component';

export const weaveProductRoutes: Routes = [
  {path: '', component: WeaveProductOverviewPageComponent},
  AuthorizedRouteFactory.createComponentRoute(RouteUtils.paths.texStyle.weaveProduct.addWeaveProduct, AddWeaveProductPageComponent, {reuse: true}, null, [], [canDeactivateRouteWithUnsavedChanges]),
  {
    path: RouteUtils.paths.texStyle.weaveProduct.duplicateWeaveProduct.path,
    component: AddWeaveProductPageComponent,
    canActivate: [canActivatePermissionGuard],
    canDeactivate: [canDeactivateRouteWithUnsavedChanges],
    data: {
      requiredPermission: RouteUtils.paths.texStyle.weaveProduct.duplicateWeaveProduct.requiredPermission
    }
  },
  {
    path: RouteUtils.paths.texStyle.weaveProduct.editWeaveProduct.path,
    component: AddWeaveProductPageComponent,
    canActivate: [canActivatePermissionGuard],
    canDeactivate: [canDeactivateRouteWithUnsavedChanges],
    data: {
      requiredPermission: RouteUtils.paths.texStyle.weaveProduct.editWeaveProduct.requiredPermission,
      reuse: true
    }
  }
];

export const weaveProductRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(weaveProductRoutes);
